<template>
  <div class="row justify-content-center shadow-sm rounded">
    <div class="d-flex align-items-center">
      <div class="text-center p-2">
        <span style="font-size: 1em; color: rgb(23,162,184)">
          Inhalte:
        </span>
      </div>
      <div class="p-2">
        <div class="btn-group">
          <!--button type="button" class="btn btn-outline-info" :disabled="disableButtons">
            <span class="far fa-bookmark"></span>
          </button-->
          <button type="button" class="btn btn-outline-info" @click="startAdd">
            <span class="fas fa-plus-circle"></span>
          </button>
          <button class="btn btn-outline-info" type="button" @click="startEdit">
            <span class="fas fa-pen"></span>
          </button>
          <button class="btn btn-outline-info" type="button" @click="startDelete">
            <span class="fas fa-minus-circle"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "User.Menu.Actions",

  methods: {
    startDelete: function() {
      this.$router.push({
        name: "provider",
        params: { mode: "delete" }
      });
    },
    startAdd: function() {
      this.$router.push({
        name: "provider",
        params: { mode: "add" }
      });
    },
    startEdit: function() {
      this.$router.push({
        name: "provider",
        params: { mode: "edit" }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
